function postSubmitChange() {
    document.querySelector(".media-before").classList.add("hidden");
    document.querySelector(".media-after").classList.remove("hidden");
}

export default postSubmitChange;
